"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimitGambleBgView = void 0;
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const GambleAssetConfig_1 = require("../config/GambleAssetConfig");
class NoLimitGambleBgView extends PIXI.Container {
    /**
     * @constructs
     */
    constructor() {
        super();
        this.init();
    }
    /**
     * @description To show the view.
     */
    show() {
        this.visible = true;
    }
    /**
     * @description When gamble module is all done.
     */
    allDone() {
        this.visible = false;
    }
    /**
     * @description To init the view.
     */
    init() {
        this.createBackground();
        this.visible = false;
    }
    /**
     * @description To create the background for the entire gamble.
     */
    createBackground() {
        const bg = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.BG)), offsetY = 50, center = 360;
        bg.anchor.set(0.5);
        bg.position.set(center, center + offsetY);
        this.addChild(bg);
    }
}
exports.NoLimitGambleBgView = NoLimitGambleBgView;
//# sourceMappingURL=NoLimitGambleBgView.js.map